import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IQuotation, IQuotationInitialState } from "./quotationModel";
import {
  createQuotationStep1,
  createQuotationStep2,
  deleteQuotation,
  getAllQuotations,
  getQuotationByID,
  updateQuotationStep1,
} from "./services/quotation.services";

const initialState: IQuotationInitialState = {
  loading: false,
  error: "",
  QuotationList: [],
  QuotationID: null,
  ActiveStep: 0,
  AccomodationDeleteIndex: -1,
  TransportDeleteIndex: -1,
  MiscellaneousDeleteIndex: -1,
  TourItineraryDeleteIndex: -1,
  QuotationDetail: {
    Name: "",
    MobileNo: "",
    EmailID: "",
    StartDate: "",
    EndDate: "",
    PickUpPlace: "",
    PickUpDate: "",
    DropPlace: "",
    DropDate: "",
    TotalRoom: null,
    TotalAdult: null,
    TotalCWB: null,
    TotalCNB: null,
    TotalAccommodationRate: null,
    DriverAllowance: null,
    TotalTax: null,
    TotalTransportation: null,
    TotalMiscellaneous: null,
    Accommodations: [],
    Transportations: [],
    Miscellaneous: [],

    Initial: "",
    LeadSourceID: null,
    SectorID: null,
    CompanyID: null,
    Type: "",
    DiscountAmt: null,
    GstPer: null,
    GstValue: null,
    isTCS: false,
    TCS: null,
    FinalAmt: null,
  },
  QuotationFilterDetails: {
    filterContactID: "",
    filterLeadID: "",
    filterInquiryID: "",
    filterName: "",
    filterMobileNo: "",
    filterEmailID: "",
    filterPickUpPlace: "",
    filterDropPlace: "",
  },
};

const quotationSlice = createSlice({
  name: "quotation",
  initialState,
  reducers: {
    clearQuotationInformation: (state) => {
      state.QuotationDetail = initialState.QuotationDetail;
    },
    setQuotationInformation: (state, action) => {
      state.QuotationDetail = action.payload;
    },
    setQuotationID: (state, action) => {
      state.QuotationID = action.payload;
    },
    clearQuotationID: (state) => {
      state.QuotationID = initialState.QuotationID;
    },
    setActiveStep: (state, action) => {
      state.ActiveStep = action.payload;
    },
    clearActiveStep: (state) => {
      state.ActiveStep = initialState.ActiveStep;
    },
    increaseActiveStep: (state) => {
      state.ActiveStep = state.ActiveStep + 1;
    },
    decreaseActiveStep: (state) => {
      state.ActiveStep = state.ActiveStep - 1;
    },
    setAccomodationDeleteIndex: (state, action) => {
      state.AccomodationDeleteIndex = action.payload;
    },
    setTransportDeleteIndex: (state, action) => {
      state.TransportDeleteIndex = action.payload;
    },
    setMiscellaneousDeleteIndex: (state, action) => {
      state.MiscellaneousDeleteIndex = action.payload;
    },
    setTourItineraryDeleteIndex: (state, action) => {
      state.TourItineraryDeleteIndex = action.payload;
    },
    setQuotationFilterDetails: (state, action) => {
      state.QuotationFilterDetails = action.payload;
    },
    clearQuotationFilterDetails: (state) => {
      state.QuotationFilterDetails = initialState.QuotationFilterDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllQuotations.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllQuotations.fulfilled,
      (state, action: PayloadAction<IQuotation[]>) => {
        state.loading = false;
        state.QuotationList = action.payload || [];
      }
    );
    builder.addCase(getAllQuotations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.QuotationList = [];
    });

    builder.addCase(createQuotationStep1.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createQuotationStep1.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createQuotationStep1.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createQuotationStep2.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createQuotationStep2.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createQuotationStep2.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateQuotationStep1.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateQuotationStep1.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateQuotationStep1.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteQuotation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteQuotation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteQuotation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getQuotationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getQuotationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.QuotationDetail = action.payload;
    });
    builder.addCase(getQuotationByID.rejected, (state, action) => {
      state.loading = false;
      state.QuotationDetail = initialState.QuotationDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setQuotationInformation,
  clearQuotationInformation,
  clearQuotationID,
  setQuotationID,
  setAccomodationDeleteIndex,
  setTransportDeleteIndex,
  setMiscellaneousDeleteIndex,
  setTourItineraryDeleteIndex,
  setActiveStep,
  clearActiveStep,
  increaseActiveStep,
  decreaseActiveStep,
  setQuotationFilterDetails,
  clearQuotationFilterDetails,
} = quotationSlice.actions;
export default quotationSlice.reducer;
